import React, { useState } from "react";
import { TextInputComponent } from "../../common/Form/Input.component";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { auth } from "../../../firebase";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";

const SignUp = ({ setCurrentView }) => {
  const registerDTO = Yup.object({
    name: Yup.string().min(2).max(50).required(),
    email: Yup.string().email().required(),
    password: Yup.string()
      .matches((/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,16}$/), "Password must contain one capital letter, one small letter, a number and a special symbol")
      .required(),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Password and comfirm password must match")
      .required(),
    
  });
  const [loading, setLoading] = useState(false);
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(registerDTO),
  });
  const submitForm = async (data) => {
    try {
      setLoading(true);
      const userCredential = await createUserWithEmailAndPassword(auth, data.email, data.password);
      await updateProfile(userCredential.user, {
        displayName: data.name
      });
      toast.success(
        "Your Account has been created successfully."
      );
      setLoading(false);
      setCurrentView("login");
    } catch (exception) {
      toast.error(exception.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="login_box">
        <form method="post" onSubmit={handleSubmit(submitForm)}>
          <div className="fromtitle">
            <p>Please enter your details to Sign up</p>

            {/* <div className='login_hr'></div> */}
          </div>
          <div className="form_body">
            <label htmlFor="name">
              Name <span>*</span>
            </label>
            <br />
            <TextInputComponent
              name="name"
              errMsg={errors?.name?.message || null}
              required:true
              control={control}
            />
            <br />
            
            <label htmlFor="email">
              Email<span>*</span>
            </label>
            <br />
            <TextInputComponent
              name="email"
              errMsg={errors?.email?.message || null}
              required:true
              control={control}
            />           
            <br />
            <label htmlFor="password">
              Password<span>*</span>
            </label>
            <br />
            <TextInputComponent
              name="password"
              type="password"
              errMsg={errors?.password?.message || null}
              required:true
              control={control}
            />
            <br />
            <label htmlFor="confirmPassword">
              Confirm Password<span>*</span>
            </label>
            <br />
            <TextInputComponent
              name="confirmPassword"
              type="password"
              errMsg={errors?.confirmPassword?.message || null}
              required:true
              control={control}
            />

            <br />
            <input
              className="submit_btn hoverBotton"
              type="submit"
              value="Sign Up"
              name="signUp_submit"
              disabled={loading}
            />
          </div>
          <div className="sign_up_p">
            <p>
              Already have an account?{" "}
              <span onClick={() => setCurrentView("login")}>Login</span>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
